import { Injectable } from '@angular/core';
import {MessageService} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(public messageService: MessageService) { }
  
  saveProfile(user: any) {
        this.messageService.add({severity: 'success', summary: 'profile saved', detail: 'profile saved for user' + user.name});          
    }
    
    
  changePassword(user: any) {
        this.messageService.add({severity: 'success', summary: 'password change', detail: 'password change user ' + user.name});          
    }
}
